import TabelaListaEmpresa from "./TabelaListaEmpresa";

export default TabelaListaEmpresa;